import { combineReducers } from "redux";

// Front
import Layout from "./layout/reducer";

// Authentication
import Login from "./auth/login/reducer";
import Profile from "./auth/profile/reducer";
import addRole from './Role/reducer'
import rolePermission from './RolePermission/reducer'
import address from './Address/reducer'
import entity from './Entity/reducer'
import userList from './User/reducer'
import  Permission  from "./permission/reducer";
import Template from "./Template/reducer"
import SMSTemplate from "./SMSTemplate/reducer";
import NotificationTemplate from "./notificationTemplate/reducer";
import ApiConfiguration from "./Configuration/ApiConfiguration/reducer";
import SystemConfiguration from "./Configuration/SystemConfiguration/reducer";

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Profile,
  rolePermission,
  address,
  entity,
  userList,
  addRole,
  Permission,  
  Template,
  SMSTemplate,
  NotificationTemplate,
  ApiConfiguration,
  SystemConfiguration,
});

export default rootReducer;
